let customSelectTouchStep;
customSelectTouchStep = { step: 0};

function fInitCustomSelects() {

    var inBrowser = typeof window !== 'undefined';
    var UA = inBrowser && window.navigator.userAgent.toLowerCase();
    var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA));

    if (isIOS) return;

    const aCustomSelects = document.querySelectorAll('.js-custom-select');

    const destroyCustomSelect = (select) => {
    const oCustomSelectList = select.querySelector('.custom-select__list');
    const oCustomSelectTrigger = select.querySelector('.custom-select__trigger');

    select.removeChild(oCustomSelectList);
    select.removeChild(oCustomSelectTrigger);
  };

  const clickHandler = (select, listEl, oCustomSelectTrigger) => {
    const setValue = listEl.getAttribute('rel');
    select.value = setValue;

    oCustomSelectTrigger.textContent = listEl.textContent;

    if ('createEvent' in document) {
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      select.dispatchEvent(evt);
    } else {
      select.fireEvent('onchange');
    }

      if (validate && select.form) {
        const invalid = validate.hasError(select);
        if (!invalid) {
            validate.removeError(select);
        }
      }

      if (select.id === 'search__sort') {
          const urlParams = new URLSearchParams(window.location.search);
          //const currentquery = urlParams.get('search');
          //const currentPage = urlParams.get('page') || '';

          const currentquery = select.getAttribute('data-search');
          const currentPage = select.getAttribute('data-page');


          window.location.href = '//' + window.location.host + window.location.pathname + "?search=" + currentquery + "&page=" + currentPage + "&sort=" + select.value;
      }

  };

  const createCustomSelect = (select) => {
    const selectContainer = select;
    const oSelect = selectContainer.querySelector('select');
    const aSelectOptions = oSelect.options;
    const oCustomSelectList = document.createElement('ul');
    const oCustomSelectTrigger = document.createElement('div');

    oSelect.classList.add('sr-only');
    oCustomSelectList.classList.add('custom-select__list');
    oCustomSelectTrigger.classList.add('custom-select__trigger');

    if (oSelect.value !== '' || oSelect.querySelector('[selected]')) {
      oCustomSelectTrigger.textContent = oSelect.value !== '' ? oSelect.querySelector(`option[value="${oSelect.value}"]`).textContent : oSelect.querySelector('[selected]').textContent;
    } else {
      oCustomSelectTrigger.textContent = aSelectOptions[0].textContent;
    }

    oSelect.addEventListener('focus', () => {
      oCustomSelectList.classList.add('is-open');
    });

      oSelect.addEventListener('blur', (e) => {
      if (e.relatedTarget !== null) {
        oCustomSelectList.classList.remove('is-open');
      }
    });

    oCustomSelectTrigger.addEventListener('click', () => {
      if (oCustomSelectList.classList.contains('is-open')) {
        oSelect.blur(); // Calls the blur EventHandler
      } else {
        oSelect.focus(); // Calls the focus EventHandler
      }
    });

    document.addEventListener('click', (event) => {
      const selectStayOpen = event.target.classList.contains('custom-select__trigger')
                 || event.target.classList.contains('form__group__label')
                 || event.target.classList.contains('sr-only');

      if (!selectStayOpen) {
        oCustomSelectList.classList.remove('is-open');
      }
    });


    for (let i = 0; i < aSelectOptions.length; i += 1) {
      const listEl = document.createElement('li');
      listEl.textContent = aSelectOptions[i].textContent;
      listEl.setAttribute('rel', aSelectOptions[i].value);
      listEl.classList.add('custom-select__list__item');

      if (aSelectOptions[i].disabled) {
        listEl.classList.add('custom-select__list__item--disabled');
      }

      oCustomSelectList.appendChild(listEl);

      listEl.addEventListener('click', () => {
          customSelectTouchStep.step = 4;
          clickHandler(oSelect, listEl, oCustomSelectTrigger);
      });
      listEl.addEventListener('touchstart', () => {
          customSelectTouchStep.step = 1;
      });
      listEl.addEventListener('touchcancel', () => {
          customSelectTouchStep.step = 2;
      });
      listEl.addEventListener('touchmove', () => {
          customSelectTouchStep.step = 3;
      });
      listEl.addEventListener('touchend', (e) => {
        if (customSelectTouchStep.step === 1) {
            e.preventDefault(); 
            e.stopPropagation();
            clickHandler(oSelect, listEl, oCustomSelectTrigger);
            oCustomSelectList.classList.remove('is-open');
        }
      });
    }

    selectContainer.appendChild(oCustomSelectTrigger);
    selectContainer.appendChild(oCustomSelectList);
  };

  for (let i = 0; i < aCustomSelects.length; i += 1) {
    const select = aCustomSelects[i];

    if (select.querySelector('.custom-select__trigger')) {
      destroyCustomSelect(select);
    }

    createCustomSelect(select);
  }
}
